export const BodyNoScroll = `
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  position: fixed;
`;
